<template>
    <div class="about-me">
        <div class="first">
            <info-section 
                :data="about_me_data" 
                :render="about_me_data.render" 
                :leave="about_me_data.leave">
            </info-section>
        </div>
        <div class="container-sb">
            <!-- BIOGRAPHY -->
            <div class="content-sb content-bio">
                <h1><span class="line">SOBRE MÍ</span></h1>
                <div class="text-image">
                    <div class="text">
                        <p>
                            <i>De Profesión, </i>Análista y Desarrollador de Sistemas de Información, enfocado en el Desarrollo Web desde hace más de 4 años. 
                            Siempre estoy adquiriendo nuevos conocimientos del mundo del desarrollo para aplicarlo en los direfentes proyectos que tengo a mi cargo.
                            Desde sitios webs corporativos, pasando por sistemas POS, hasta plataformas de cursos online, todo esto lo hago posible gracias a la disciplina y al maravilloso universo de la programación.
                        </p>
                    </div>
                    <div class="image">
                        <img src="@/assets/images/home/me.jpg" class="profile-picture" alt="Sebastian Báez - Desarrollador web">
                    </div>
                </div>
            </div>
            <!-- PASSIONS -->
            <div class="content-sb content-passions" id="content_passions">
                <h1><span class="line">PASIONES</span></h1>
                <div class="passions">
                    <!-- Item -->
                    <div class="item">
                        <div class="image">
                            <!-- <img src="@/assets/images/about-me/animated-technology.svg" v-if="show_passions_images" alt="Tecnología"> -->
                            <icon-technology v-if="show_passions_images"></icon-technology>
                        </div>
                        <h3>TECNOLOGÍA</h3>
                        <p>
                            Desde que tengo memoria me han gustado las cosas relacionadas con la tecnología, 
                            empecé con el hardware de computadoras, después descubrí el software, este software se hacia con algo llamado 
                            "<i>lenguajes de programación</i>" y desde entonces me estoy adentrando más y más en este maravilloso mundo.
                        </p>
                    </div>
                    <!-- Item -->
                    <div class="item">
                        <div class="image">
                            <!-- <img src="@/assets/images/about-me/animated-read.svg" v-if="show_passions_images" alt="Lectura"> -->
                            <icon-read v-if="show_passions_images"></icon-read>
                        </div>
                        <h3>LECTURA</h3>
                        <p>
                            Un libro puede ser una increíble historia de aventuras y magia o pueden ser de 30 años de experiencia en  un área 
                            especifica, que una persona decidió plasmar en las páginas. En lo personal me fascinan los libros de fantasía y de misterio, sin dejar a un lado los de 
                            educación financiera.
                        </p>
                    </div>
                    <!-- Item -->
                    <div class="item">
                        <div class="image">
                            <!-- <img src="@/assets/images/about-me/animated-animals.svg" v-if="show_passions_images" alt="Animales"> -->
                            <icon-animals v-if="show_passions_images"></icon-animals>
                        </div>
                        <h3>ANIMALES</h3>
                        <p>
                            Si me preguntaran cuál es la criatura más noble y hermosa jamas creada, me costaría demasiado elegir, pero al final me decantaría
                            por el perro, no por nada se dice que es el mejor amigo del hombre. Uno de mis más grandes sueños es crear una fundación que los proteja
                            y vele por sus derechos.
                        </p>
                    </div>
                </div>
            </div>
            <!-- SKILLS -->
            <div class="content-sb content-skills" id="content_skills">
                <h1><span class="line">HABILIDADES</span></h1>
                <div class="skills">
                    <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/html-css.svg" alt="HTML - CSS">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">HTML5-CSS3</h3>
                                <h3>96<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="96"></div>
                            </div>
                        </div>
                    </div>
                    <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/sass.svg" alt="SASS">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">SASS</h3>
                                <h3>87<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="87"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/javascript.svg" alt="Javascript">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">JAVASCRIPT</h3>
                                <h3>80<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="80"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/vuejs.svg" alt="Vue.js">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">VUE.JS</h3>
                                <h3>93<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="93"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/php.svg" alt="Vue.js">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">PHP</h3>
                                <h3>85<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="85"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/lumen.svg" alt="Vue.js">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">LARAVEL LUMEN</h3>
                                <h3>81<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="81"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/mysql.svg" alt="MySQL">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">MySQL</h3>
                                <h3>75<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="75"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/git.svg" alt="Git">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">GIT</h3>
                                <h3>77<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="77"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/wordpress.svg" alt="Wordpress">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">WORDPRESS</h3>
                                <h3>83<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="83"></div>
                            </div>
                        </div>
                    </div>
                   <!-- ITEM -->
                    <div class="item">
                        <!-- Image -->
                        <div class="image">
                            <img src="@/assets/images/about-me/skills/illustrator.svg" alt="Illustrator">
                        </div>
                        <!-- Percentage -->
                        <div class="percentage">
                            <div class="top">
                                <h3 class="name">ILLUSTRATOR</h3>
                                <h3>33<span>%</span></h3>
                            </div>
                            <div class="bar">
                                <div class="bg percentage-number" percentage-number="33"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FOOTER -->
        <footer-sb></footer-sb>
    </div>
</template>


<script>
import FirstBannerComponent from '@/components/FirstBannerComponent'
import IconTechnologyComponent from '@/components/PassionsIcons/IconTechnologyComponent'
import IconReadComponent from '@/components/PassionsIcons/IconReadComponent'
import IconAnimalsComponent from '@/components/PassionsIcons/IconAnimalsComponent'

import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax"
import ScrollMagic from 'scrollmagic'

export default {
    components: {
        'first-banner': FirstBannerComponent,
        'icon-technology': IconTechnologyComponent,
        'icon-read': IconReadComponent,
        'icon-animals': IconAnimalsComponent
    },
    data() {
        return {
            show_passions_images: false,
            // About Me
            about_me_data: {
                render: false,
                leave: false,
                title: 'QUIÉN SOY YO',
                description: 'Amante de la Tecnología, los Animales y de adquirir Nuevo Conocimiento.',
                buttonText: 'Explorar',
                button_link: { type: 'ext', link: 'https://www.linkedin.com/in/sebastian-b%C3%A1ez-a461a2176/' },
                image: { full: true, url: 'home/me.jpg' }
            }
        }
    },
    mounted() {
        let controller = new ScrollMagic.Controller(),
            app = this;

       	let skills_scene = new ScrollMagic.Scene({triggerElement: "#content_skills"})
			.on("enter", function () {
                app.setPercentajesToBar();
            })
            .addTo(controller);
        
        let controller_3 = new ScrollMagic.Controller();
       	let passions_scene = new ScrollMagic.Scene({triggerElement: "#content_passions"})
			.on("enter", function () {
                app.show_passions_images = true;
            })
			.addTo(controller_3);
    },
    methods: {
        setPercentajesToBar() {
            let percentages = document.getElementsByClassName('percentage-number');
    
            for (let i = 0; i < percentages.length; i++) {
                percentages[i].style.width = percentages[i].getAttribute('percentage-number') + '%';
            }
        }
    }
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.about-me {
    p { @extend %default-paragrahp; }
    position: relative;
    
    .first {
        position: relative;
        color: #FFFFFF;
        background-color: $main-black-2;
        height: 100vh;
    }

    .container-sb {
        .content-bio {
            h1 { @extend %default-content-title; }

            .text-image {
                // TEXT
                .text {
                    margin-bottom: 1.5rem;
                    @media (min-width: 700px) {
                        margin-bottom: 2.8rem
                    }

                    @media (min-width: 1024px) {
                        width: 48%
                    }
                }
                // IMAGE
                .image {
                    .profile-picture{
                        width: 100%
                    }

                    @media (min-width: 1024px) {
                        width: 48%
                    }
                }

                @media (min-width: 1024px) {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between
                }
            }
        }

        .content-passions {
            h1 { @extend %default-content-title; }
            .passions {
                .item {
                    margin: 2rem 0px 2rem 0px;
                    
                    .image {
                        text-align: center;
                        margin-bottom: 0.5rem;
                        min-height: 100px;
                        .svg { width: 110px; margin: auto }
                    }
                    h3 {
                        text-align: center;
                        margin-bottom: 1rem
                    }

                    @media (min-width: 760px) {
                        .image { min-height: 140px; .svg { width: 130px } }
                        h3 { font-size: 1.5rem }
                    }

                    @media (min-width: 1024px) { width: 32% }

                    @media (min-width: 1200px) { 
                        width: 30%;
                        .image { min-height: 160px; .svg { width: 160px } }
                    }
                }

                @media (min-width: 1024px) {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between
                }
            }
        }

        .content-skills {
            h1 { @extend %default-content-title; }

            .skills {
                margin-top: 2.5rem;
                .item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 1.5rem;

                    .image {
                        margin-right: 12px;
                        img { width: 45px }
                    }

                    .percentage {
                        width: 100%;

                        .top {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 14px;

                            h3 { font-size: 0.9rem; span { font-size: 0.8rem } }
                        }
                        .bar {
                            border-radius: 50px;
                            height: 10px; 
                            background-color: #FFFFFF;
                            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);

                            .bg {
                                transition: width 1.5s;
                                width: 0px;
                                height: 10px; 
                                border-radius: 50px;
                                @extend %default-gradient;
                            }
                        }
                    }

                    @media (min-width: 760px) {
                        margin-bottom: 2.5rem;

                        .image {
                            margin-right: 18px;
                            img { width: 60px }
                        }

                        .percentage {
                            .top {
                                margin-bottom: 18px;
                                h3 { font-size: 1.2rem; span { font-size: 1rem } }    
                            }

                            .bar {
                                height: 15px; 
                                .bg { height: 15px }
                            }
                        }
                    }

                    @media (min-width: 1024px) { width: 47% }
                }

                @media (min-width: 1024px) {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap
                }
            }
        }
    }
}
</style>